module.exports = __webpack_public_path__ + "static/media/0.c28bfb3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/0.png
// module id = 1505
// module chunks = 0